import { render, staticRenderFns } from "./TimelinePromotedItem.vue?vue&type=template&id=a7783b10&"
import script from "./TimelinePromotedItem.vue?vue&type=script&lang=js&"
export * from "./TimelinePromotedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports